/* eslint-disable eqeqeq */
import { useParams } from "react-router-dom";
import { useMemo, useState, useCallback } from "react";
import { ModalCloseBtn } from "../../../primaryComponents";
import { useGetCategoriesLinkedToProduct } from "../../../../hooks/api/queries";
import styles from "./styles.module.scss";
import { truncateString } from "../../../../helpers";
import { useSellModeFilters } from "../../../../hooks/useSellModeFilters";
import primaryComponents from "../../../primaryComponents";
import secondaryComponents from "../..";

export const AllCategoriesView = ({
  closeModal = () => {},
  isMobileView = false,
}) => {
  const { store_id } = useParams();
  const { data: categories = [], isLoading } = useGetCategoriesLinkedToProduct({
    queries: `?store_id=${store_id}`,
  });

  const { search, filterByCategory } = useSellModeFilters();
  const [value, setValue] = useState("");

  // Memoized category filtering for performance
  const filteredCategories = useMemo(
    () =>
      categories.filter((category) =>
        category?.name?.toLowerCase()?.includes(value?.trim()?.toLowerCase()),
      ),
    [categories, value],
  );

  // Handle category selection
  const handleCategorySelect = useCallback(
    (categoryId) => {
      filterByCategory(categoryId);
      closeModal();
    },
    [filterByCategory, closeModal],
  );

  return (
    <section
      aria-labelledby="category-heading"
      className={`${styles.allCategoriesView} ${isMobileView ? styles.mobileView : ""}`}
    >
      {/* Header */}
      {!isMobileView ? (
        <>
          <div className={styles.allCategoriesView__header}>
            <h4 id="category-heading" className="mb-0">
              Select a Category
            </h4>
            <ModalCloseBtn onClick={closeModal} />
          </div>
          <hr />
        </>
      ) : (
        <div>
          <div className={styles.currentSelection}>
            <span className="dark--text font-weight-normal">
              Current Selection:
            </span>
            <h6 className="mb-0">
              {filteredCategories?.find(
                (category) => `${category?.id}` === search.get("category_id"),
              )?.name || "All"}
            </h6>
          </div>
        </div>
      )}

      {/* Search Field */}
      <div className={styles.allCategoriesView__search}>
        <primaryComponents.SearchField
          showsearchBtn={false}
          showClearBtn={true}
          triggerOnInput={true}
          placeholder="Search Category"
          useBorderImage={true}
          borderColor="#1e016f"
          value={value}
          trigger={setValue}
        />
      </div>
      <hr />

      {/* Category List */}
      <secondaryComponents.LoaderHelper isLoading={isLoading} classNames="py-4">
        <div className={styles.allCategoriesView__items} aria-live="polite">
          <button
            type="button"
            className={`${styles.category} ${!search?.get("category_id") ? styles.active : ""}`}
            onClick={() => handleCategorySelect(null)}
            aria-pressed={!search?.get("category_id")}
          >
            All
          </button>
          {filteredCategories.map((category) => {
            const isActive = search.get("category_id") == category.id;
            return (
              <button
                key={category.id}
                className={`${styles.category} ${isActive ? styles.active : ""}`}
                onClick={() => {
                  handleCategorySelect(category.id);
                }}
                aria-pressed={isActive}
              >
                <span>{truncateString(category?.name, 50)}</span>
              </button>
            );
          })}
        </div>
      </secondaryComponents.LoaderHelper>
    </section>
  );
};
